/* eslint-disable no-else-return */
import { get, isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { bool, number, object, string } from 'yup'

import { checkProductDependencyFulfilled, unselectedProduct } from '../components/form/Pages/Products/utils'

export default function productsListHook({
  paidMap,
  filteredProducts = [],
  productGroups,
  preselectedProduct,
  initialValues = {},
  isForSubEvents,
  filteredSubs = [],
}) {
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [initValues, setInitValues] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [schema, setSchema] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [childProductList, setChildProductList] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [formProductIdMap, setFormProductIdMap] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [errorType, setErrorType] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [errorText, setErrorText] = useState({})
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [pgClone, setPgClone] = useState([...productGroups])
  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  const [groupMap, setGroupMap] = useState(
    productGroups.reduce((a, pg) => {
      a[pg.id] = []
      return a
    }, {})
  )

  // biome-ignore lint/correctness/useHookAtTopLevel: TODO(biome-2.4): newly detected in 2.4 upgrade
  useEffect(() => {
    let tempInitValues = {}
    const tempSchema = {}
    const tempChildProductList = {}
    const tempGroupMap = productGroups.reduce((a, pg) => {
      a[pg.id] = []
      return a
    }, {})
    const tempPgClone = [...productGroups]
    const tempFormProductIdMap = {}
    const tempErrorArr = {}

    // process product
    filteredProducts.forEach(p => {
      const id = p.sfid

      tempFormProductIdMap[id] = p.formProductId
      tempErrorArr[id] = p.formProductId

      // generate initial values
      const depFulfilled = checkProductDependencyFulfilled(p.dependentProducts, paidMap)
      // biome-ignore lint/complexity/useOptionalChain: TODO
      const isPaid = paidMap[id] && paidMap[id].isPaid
      const autoSelect = p.isMandatory || id === preselectedProduct
      const showPaid = !p.allowMultiplePurchase && isPaid
      const isQualificationStandard =
        // biome-ignore lint/complexity/useOptionalChain: TODO(biome-2.4): newly detected in 2.4 upgrade
        p.type === 'Event' &&
        p.subType === 'Event Entry' &&
        p.productAttributes &&
        p.productAttributes[0] &&
        p.productAttributes[0].productAttributeName.toLowerCase() === 'qualification standard'

      tempInitValues[id] =
        autoSelect && depFulfilled && !showPaid
          ? {
              quantity: p.allowMultiplePurchase ? p.minimumPurchaseLimit || '1' : '1',
              checked: true,
              formProductId: p.formProductId,
              ...(isQualificationStandard && { attributeValue: undefined, attributeId: undefined }),
              ...(p.type === 'Add-on' && p.productAttributes && { attributeId: undefined }),
            }
          : {
              ...unselectedProduct,
              ...(isQualificationStandard && { attributeValue: undefined, attributeId: undefined }),
              ...(p.type === 'Add-on' && p.productAttributes && { attributeId: undefined }),
            }

      // generate validation schema
      tempSchema[id] = object({
        checked: bool(),
        quantity: number().test({
          name: `validation for ${id}`,
          message: 'Required',
          test(value) {
            // eslint-disable-next-line react/no-this-in-sfc
            const { checked } = this.parent
            if (!checked) {
              return true
            }
            if (p.purchaseLimit) {
              if (p.minimumPurchaseLimit && Number(value) < p.minimumPurchaseLimit) {
                setErrorType(state => ({ ...state, [p.sfid]: 'min' }))
              } else if (Number(value) > p.purchaseLimit) {
                setErrorType(state => ({ ...state, [p.sfid]: 'max' }))
              }

              return Number(value) >= (p.minimumPurchaseLimit || 0) && Number(value) <= p.purchaseLimit
            }
            return Number(value) > 0
          },
        }),
        attributeId: number().test({
          name: `validation for ${id}`,
          message: 'Attribute is required',
          test(value) {
            const { checked } = this.parent
            if (!checked) {
              return true
            } else if (p.type === 'Add-on' && p.productAttributes?.length > 1) {
              const { optionIds } = this.parent
              return (
                Array.isArray(optionIds) &&
                optionIds.length === p.productAttributes.length &&
                optionIds.every(optionId => optionId != null)
              )
            } else if (p.type === 'Add-on' && !isEmpty(p.productAttributes)) {
              const { isMandatory } = p.productAttributes[0]
              if (!isMandatory) {
                return true
              } else {
                return !!value
              }
            } else {
              return true
            }
          },
        }),
        attributeValue: string()
          .test({
            name: `validation for ${id}`,
            message: `${isQualificationStandard ? 'Qualification Standard' : 'Attribute value'} is required`,
            test(value) {
              const { checked } = this.parent
              if (!checked) {
                setErrorText(prev => ({
                  ...prev,
                  [p.sfid]: '',
                }))
                return true
              } else if (isQualificationStandard) {
                const qStd = p.productAttributes[0].items[0].name
                if (qStd.includes('HH:MM:SS') && value) {
                  const valueMatch = /^[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}$/.test(value)
                  setErrorText(prev => ({
                    ...prev,
                    [p.sfid]: !valueMatch ? 'Invalid value - format should be similar to XX:XX:XX' : '',
                  }))
                  return !!valueMatch
                } else if (qStd.includes('MM.CMCM') && value) {
                  const valueMatch = /^[0-9]{1,2}\.[0-9]{1,2}$/.test(value)
                  setErrorText(prev => ({
                    ...prev,
                    [p.sfid]: !valueMatch ? 'Invalid value - format should be similar to XX.XX' : '',
                  }))
                  return !!valueMatch
                } else if (qStd.includes('MM:SS.TSHS') && value) {
                  const valueMatch = /^[0-9]{1,2}:[0-9]{1,2}\.[0-9]{1,2}$/.test(value)
                  setErrorText(prev => ({
                    ...prev,
                    [p.sfid]: !valueMatch ? 'Invalid value - format should be similar to XX:XX.XX' : '',
                  }))
                  return !!valueMatch
                } else if (qStd.includes('SS.TSHS') && value) {
                  const valueMatch = /^[0-9]{1,2}\.[0-9]{1,2}$/.test(value)
                  setErrorText(prev => ({
                    ...prev,
                    [p.sfid]: !valueMatch ? 'Invalid value - format should be similar to XX.XX' : '',
                  }))
                  return !!valueMatch
                } else if (qStd.includes('M.CMCM') && value) {
                  const valueMatch = /^[0-9]{1}\.[0-9]{1,2}$/.test(value)
                  setErrorText(prev => ({
                    ...prev,
                    [p.sfid]: !valueMatch ? 'Invalid value - format should be similar to X.XX' : '',
                  }))
                  return !!valueMatch
                } else {
                  const { isMandatory } = p.productAttributes[0]
                  if (!isMandatory) {
                    return true
                  } else {
                    setErrorText(prev => ({
                      ...prev,
                      [p.sfid]: 'Qualification Standard is required',
                    }))
                    return false
                  }
                }
              } else {
                return true
              }
            },
          })
          .nullable(),
      })

      // generate child product list
      const depProducts = p.dependentProducts || []
      if (depProducts.length > 0) {
        depProducts.forEach(dp => {
          const dpId = dp.primaryProduct
          const oldDpList = get(tempChildProductList, dpId) || {}
          tempChildProductList[dpId] = {
            ...oldDpList,
            [id]: {
              isMandatory: p.isMandatory,
              mustBePaid: dp.mustBePaid,
              allowMultiplePurchase: p.allowMultiplePurchase,
            },
          }
        })
      }

      // fill into product group
      if (p.relatedProductGroup && tempGroupMap[p.relatedProductGroup]) {
        tempGroupMap[p.relatedProductGroup].push(p)
      } else {
        tempGroupMap[p.sfid] = [p]
        tempPgClone.push({
          orderNumber: p.orderNumber,
          id,
          organisationLevel: p.organisationLevel,
          isLocked: p.isLocked,
        })
      }
    })

    if (initialValues && Object.keys(initialValues).length > 0) {
      tempInitValues = Object.keys(initialValues).reduce((a, key) => {
        // if product filtered out by the display rule
        if (!filteredProducts.some(p => p.sfid === key)) {
          a[key] = unselectedProduct
          // filter out the child product
          const cpList = tempChildProductList[key] || {}
          Object.keys(cpList).forEach(cp => {
            a[cp] = unselectedProduct
          })
          return a
        }
        a[key] = initialValues[key]
        return a
      }, {})
    }

    // filter out other mandatory products not in selected sub events
    if (isForSubEvents && filteredSubs) {
      /* eslint-disable-next-line prefer-const */
      const fsProdIds = []
      filteredSubs.forEach(s => s.products.forEach(p => fsProdIds.push(p.sfid)))
      Object.keys(tempInitValues).forEach(t => {
        if (!fsProdIds.includes(t)) {
          tempInitValues[t] = unselectedProduct
        }
      })
    }

    setInitValues(tempInitValues)
    setSchema(tempSchema)
    setChildProductList(tempChildProductList)
    setGroupMap(tempGroupMap)
    setPgClone(tempPgClone)
    setFormProductIdMap(tempFormProductIdMap)
    setErrorType(tempErrorArr)
  }, [])

  return {
    initValues,
    schema,
    childProductList,
    errorType,
    pgClone,
    groupMap,
    formProductIdMap,
    errorText,
  }
}
